import styled from 'styled-components';

export const CopyInputStyled = styled.div`
  position: relative;
`;

export const CopyInputTopArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  user-select: none;
`;
